import { motion } from "framer-motion";
import { IMAGES } from "../data/content";

const TILES = [
    { type: "img", src: IMAGES.gardenSeating, alt: "Garden seating under Uncover umbrellas", span: "md:col-span-2 md:row-span-2", testid: "gallery-img-garden" },
    { type: "quote", text: "Uncover more than food. Uncover life.", bg: "#00958C", testid: "gallery-quote-1" },
    { type: "img", src: "/gallery/DSC05604.webp", alt: "The entrance gate of Uncover Avenue", span: "", testid: "gallery-img-entrance" },
    { type: "img", src: "/gallery/DSC05744.webp", alt: "Striped cabana seating in the garden", span: "", testid: "gallery-img-cabana" },
    { type: "quote", text: "Calm. Pause. Flavour.", bg: "#F0841B", testid: "gallery-quote-2" },
    { type: "img", src: "/gallery/DSC05772.webp", alt: "Round daybed cabana under the trees", span: "", testid: "gallery-img-daybed" },
    { type: "img", src: "/gallery/1.webp", alt: "A signature Esak dish", span: "", testid: "gallery-img-dish" },
    { type: "img", src: "/gallery/DSC09452.webp", alt: "Evening at Esak, lily and the glowing neon sign", span: "", testid: "gallery-img-neon" },
];

export const Gallery = () => {
    return (
        <section id="gallery" className="py-24 md:py-32 px-6 md:px-10" data-testid="gallery-section">
            <div className="max-w-7xl mx-auto">
                <motion.div
                    initial={{ opacity: 0, y: 32 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.7 }}
                >
                    <p className="font-serif-brand italic text-xl text-[#F0841B] mb-3">Moments that matter</p>
                    <h2 className="text-4xl md:text-5xl font-bold tracking-tighter text-[#262055]" data-testid="gallery-headline">
                        Inside the Avenue
                    </h2>
                </motion.div>

                <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 md:grid-flow-dense auto-rows-[240px] gap-5" data-testid="gallery-grid">
                    {TILES.map((t, i) => (
                        <motion.div
                            key={t.testid}
                            initial={{ opacity: 0, y: 28 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-40px" }}
                            transition={{ duration: 0.55, delay: (i % 4) * 0.08 }}
                            className={`rounded-3xl overflow-hidden hover:-translate-y-1 hover:shadow-2xl transition-[transform,box-shadow] duration-300 ${t.span || ""}`}
                            data-testid={t.testid}
                        >
                            {t.type === "img" ? (
                                <img src={t.src} alt={t.alt} className="w-full h-full object-cover" loading="lazy" />
                            ) : (
                                <div className="w-full h-full flex items-center justify-center p-8" style={{ backgroundColor: t.bg }}>
                                    <p className="font-serif-brand italic text-xl md:text-2xl text-white text-center leading-snug">{t.text}</p>
                                </div>
                            )}
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};
